import React from 'react';

export default function LoadMoreButton({hasNext, loading, onClick}) {
  if (!hasNext) {
    return <button type='button'
                   disabled
                   className="btn btn-light btn-block disabled">没有更多了
    </button>
  }

  return (
      <button type='button'
              onClick={onClick}
              disabled={loading}
              className="btn btn-light btn-block">
        {loading ? (
            <span>
                                  <span className="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
              &nbsp;加载中 ...
                                  </span>
        ) : '显示更多'}
      </button>

  )

}
